// src/components/discussion/context.js
import { createContext, useContext } from "react";

export const DiscussionContext = createContext(null);

export function useDiscussion() {
  const ctx = useContext(DiscussionContext);
  if (!ctx)
    throw new Error("useDiscussion must be used inside DiscussionProvider");
  return ctx;
}
